export function createState(entityId, source) {
    return {
        entityId,
        disposed: false,
        source: { ...source, generation: 0, status: 'awaiting-table-reset' },
        activeSymbols: [],
        roundSymbols: [],
        resetCoverage: [],
        rows: [],
        unmatchedAt: new Map(),
        parity: new Map(),
        pagedRowKeys: new Set(),
        initial: 'uncommitted',
        caughtUp: false,
        reachedEnd: false,
        liveCatchUp: 'inactive',
        liveTopRecovery: false,
        liveDue: false,
        manualUp: false,
        fetch: { status: 'idle' },
        pending: [],
        nextToken: 1,
        nextRequestId: 1,
        nextAutomaticClass: 'upward',
        backfill: { status: 'none' },
        lead: { rows: [], refresh: { status: 'due' } },
        measurement: { scrollTop: 0, viewportHeight: 0, heights: new Map() },
    };
}
//# sourceMappingURL=initial.js.map